import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "minus",
  "use": "minus-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"minus\">\r\n<title>minus</title>\r\n<path fill=\"#ff6b4c\" d=\"M0 14.857h32v2.286h-32v-2.286z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol